/**
 * Layout wrapper for Portal Edge font package rows: renders children inside
 * `font-package-file-actions-list` and appends the upload constraints info tooltip.
 */

import { FC, ReactNode } from 'react';
import { Tooltip } from '../../../../../components/tooltip/tooltip';
import Icon from '../../../../../components/icons/icon/icon';
import IconInfo from '../../../../../components/icons/icon-info/icon-info';

const FONT_PACKAGE_UPLOAD_TOOLTIP =
    'zip files <5mb, total size of uncompressed zip file <15mb, a font file <2mb, only font files inside a root directory of a zip file allowed ';

interface IFontPackageFileActionsListProps {
    children: ReactNode;
}

const FontPackageFileActionsList: FC<IFontPackageFileActionsListProps> = ({ children }) => (
    <div className="font-package-file-actions-list">
        {children}
        <div className="font-package-actions">
            <Tooltip content={FONT_PACKAGE_UPLOAD_TOOLTIP}>
                <Icon Component={IconInfo} />
            </Tooltip>
        </div>
    </div>
);

export default FontPackageFileActionsList;
